import { Search, X } from 'lucide-react';
import { forwardRef } from 'react';

interface HelpSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export const HelpSearchBar = forwardRef<HTMLInputElement, HelpSearchBarProps>(
  function HelpSearchBar({ value, onChange }, ref) {
    return (
      <div className="mb-4">
        <div className="relative">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-[17px] w-[17px] -translate-y-1/2 text-subtle" />
          <input
            ref={ref}
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Busca un tema, ej: anular factura"
            autoComplete="off"
            className="w-full rounded-md border py-2.5 pl-9 pr-9 text-ui-base text-primary outline-none transition-shadow placeholder:text-subtle focus:border-brand focus:ring-4 focus:ring-[var(--primary-light)]"
          />
          {value.trim() !== '' && (
            <button
              type="button"
              aria-label="Limpiar búsqueda"
              onClick={() => onChange('')}
              className="absolute right-2 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full bg-surface-2 text-muted"
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </div>
      </div>
    );
  }
);
